import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45maintenance_45global from "/app/app/middleware/01.maintenance.global.ts";
import _02_45auth_45init_45global from "/app/app/middleware/02.auth-init.global.ts";
import _03_45select_45company_45global from "/app/app/middleware/03.select-company.global.ts";
import admin_45redirects_45global from "/app/app/middleware/admin-redirects.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45maintenance_45global,
  _02_45auth_45init_45global,
  _03_45select_45company_45global,
  admin_45redirects_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}